import React from 'react';
import { Save, Printer, ArrowLeft, Trash2 } from 'lucide-react';

const WeightTagToolbar = ({ 
    loading,
    onSave,
    onPrint,
    onNavigateBack,
    onDelete,
    id 
}) => {
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="btn-group">
                            <button 
                                className="btn btn-outline-secondary"
                                onClick={onNavigateBack}
                                title="Back to List"
                            >
                                <ArrowLeft size={18} />
                            </button>
                            {id && (
                                <button 
                                    className="btn btn-outline-secondary"
                                    onClick={onPrint}
                                    title="Print Weight Tag"
                                >
                                    <Printer size={18} />
                                </button>
                            )}
                            <button 
                                type="submit"
                                className="btn btn-outline-primary"
                                onClick={onSave}
                                disabled={loading}
                                title={loading ? 'Saving...' : 'Save Weight Tag'}
                            >
                                <Save size={18} />
                            </button>
                        </div>
                    </div>
                    
                    {id && (
                        <div className="d-flex align-items-center">
                            <div className="btn-group">
                                <button 
                                    className="btn btn-outline-danger"
                                    onClick={onDelete}
                                    title="Delete Weight Tag"
                                >
                                    <Trash2 size={18} />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WeightTagToolbar;